"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractInterfaceResponseToJSON = exports.ContractInterfaceResponseFromJSONTyped = exports.ContractInterfaceResponseFromJSON = void 0;
function ContractInterfaceResponseFromJSON(json) {
    return ContractInterfaceResponseFromJSONTyped(json, false);
}
exports.ContractInterfaceResponseFromJSON = ContractInterfaceResponseFromJSON;
function ContractInterfaceResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'functions': json['functions'],
        'variables': json['variables'],
        'maps': json['maps'],
        'fungible_tokens': json['fungible_tokens'],
        'non_fungible_tokens': json['non_fungible_tokens'],
    };
}
exports.ContractInterfaceResponseFromJSONTyped = ContractInterfaceResponseFromJSONTyped;
function ContractInterfaceResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'functions': value.functions,
        'variables': value.variables,
        'maps': value.maps,
        'fungible_tokens': value.fungible_tokens,
        'non_fungible_tokens': value.non_fungible_tokens,
    };
}
exports.ContractInterfaceResponseToJSON = ContractInterfaceResponseToJSON;
//# sourceMappingURL=ContractInterfaceResponse.js.map